/**
 * Settings module translations - Buttons section
 */

const buttons = {
  addPeppolNumber: "Add peppol number",
  applyForPeppolNumber: "Apply for peppol number",
  addTaxId: "Add Tax ID",
  addBankAccount: "Add bank account",
  addCountry: "Add country",
  edit: "Edit",
  delete: "Delete",
  cancel: "Cancel",
  save: "Save",
  submit: "Submit",
  manageProducts: "Manage products",
  addKsefToken: "Add KSeF token",
  manageKsefToken: "Manage KSeF token",
  replaceKsefToken: "Replace token",
  removeKsefToken: "Remove token",
  editLanguage: "Edit language",
  setLanguage: "Set language",
  changeStatus: "Change Status",
  uploadFiles: "Upload Files",
  addRegistrationInfo: "Add registration info",
  addProductLine: "Add product line",
};

export default buttons;
